import React from 'react';

import { makeStyles, createStyles } from '@material-ui/core/styles';

import { DerivativeMediumType } from '@catalogit/common/lib/types/media';

const useStyles = makeStyles(() =>
  createStyles({
    medium: {
      position: 'relative',
      width: '100%',
      height: 0
    },

    mediumImg: {
      display: 'block',
      position: 'absolute',
      width: '100%', // TODO ??? should this be maxWidth
      maxWidth: '100%',
      maxHeight: '100%',
      lineHeight: 1
    }
  })
);

interface SizedImageProps {
  medium: DerivativeMediumType;
  alt: string;
  onClick?: React.MouseEventHandler<HTMLDivElement> | undefined;
  style?: React.CSSProperties;
}

const SizedImage = ({
  medium,
  alt,
  onClick,
  style
}: SizedImageProps): React.ReactElement => {
  const classes = useStyles();
  return (
    <div
      className={classes.medium}
      style={{
        paddingBottom: `${(medium.height / medium.width) * 100}%`,
        ...style
      }}
      onClick={onClick}
    >
      <img className={classes.mediumImg} src={medium.path} alt={alt} />
    </div>
  );
};

export default SizedImage;
